import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import styled from "styled-components";

import Swal from 'sweetalert2'


const Section = styled.div`
  height: 100vh;
  scroll-snap-align: center;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  font-weight: 200;
  color: white;
`;

const Form = styled.form`
  width: 500px;
  display: flex;
  flex-direction: column;
  gap: 25px;

  @media only screen and (max-width: 768px) {
    width: 300px;
  }
`;

const Input = styled.input`
  padding: 20px;
  background-color: #e8e6e6;
  border: none;
  border-radius: 5px;
`;

const TextArea = styled.textarea`
  padding: 20px;
  border: none;
  border-radius: 5px;
  background-color: #e8e6e6;
`;
const SuccessMessage = styled.p`
  color: white;
`;


const Button = styled.button`
  background-color: #C770f0;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  padding: 20px;
`;

const Contact = () => {
  const ref = useRef();
  const [success, setSuccess] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_s3xol4f",
        "template_v79nqin",
        ref.current,
        "LSVkCdr2Ej-t5JoUq"
      )
      .then(
        (result) => {
          console.log(result.text);
          setSuccess(true);
        },
        (error) => {
          console.log(error.text);
          setSuccess(false);
        }
      );
  };
    if (success) {
      Swal.fire({
        icon: "success",
        title: "Your message has been sent. We'll get back to you soon :)",
        showConfirmButton: false,
        timer: 1500
      });
  }

  return (
    <Section>
      <Container>
        <Left>
          <Form ref={ref} onSubmit={handleSubmit}>
            <Title><span className="purple"> CONTACT </span>ME</Title>
            <Input placeholder="Name" name="name" />
            <Input placeholder="Email" name="email" />
            <TextArea
              placeholder="Write your message"
              name="message"
              rows={10}
            />
            <Button type="submit">Send</Button>
            {success &&
             <SuccessMessage>
              Your message has been sent successfully!
           </SuccessMessage>
              }
          </Form>
        </Left>
      </Container>
    </Section>
  );
};

export default Contact;
